import {StatusCodeE} from "../model/models";

export class UtilsService {
    static EU_CURRENCY: string = "€"
    static DATE_FORMAT: string = "DD-MM-YYYY"

    static getCurrency() {
        return this.EU_CURRENCY;
    }

    static getDateFormat() {
        return this.DATE_FORMAT
    }

    static replaceId(url: string, id: string | undefined) {
        let returnUrl = url;
        if (id !== undefined) {
            returnUrl = url.replace(":id", id);
        }
        return returnUrl;
    }

    static replaceUserAndCombinatorID(url: string, userID: string | undefined, combinatorID: string | undefined) {
        let returnUrl = url;
        if (userID !== undefined) {
            returnUrl = returnUrl.replace(":id", userID);
        }
        if (combinatorID !== undefined) {
            returnUrl = returnUrl.replace(":combinatorIdFromExt", combinatorID);
        }
        return returnUrl;
    }

    static replaceStatus(url: string, status: StatusCodeE) {
        let returnUrl = url;
        if (status !== undefined) {
            returnUrl = url.replace(":status", status);
        }
        return returnUrl;
    }

    static formatNumber = (value: number | undefined) => {
        if (value == null) return
        return value.toLocaleString("it-IT", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    };

    static formatAmountRange = (range?: [number, number] | number[] | undefined): string => {
        if (!range || range.length !== 2) return '';
        return range.map(UtilsService.formatNumber).join(' - ');
    };


    static formatDateString = (dateString: string | null) => {
        if (!dateString)
            return ""
        const date = new Date(dateString);

        return this.formatDate(date);
    };

    static formatDate(date: Date) {
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour12: false, // Usa il formato a 24 ore
        };
        return date.toLocaleString('it-IT', options).replace(',', '');
    }

    static formatDateHour = (dateString: string | null) => {
        if (!dateString)
            return ""
        const date = new Date(dateString);

        const options: Intl.DateTimeFormatOptions = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        };
        return date.toLocaleString('it-IT', options).replace(',', '');
    };

    static isValidEmail = (email: string) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    static isValidPhone = (phone: string) =>
        /^\d{8,11}$/.test(phone);
}